// NEUMA email capture in the footer.
// Tries POST to /api/subscribe; on failure, surfaces the fallback mailto.

const ENDPOINT = '/api/subscribe';
const FALLBACK_EMAIL = 'kris.puckett@me.com';

export function initSubscribe(): void {
  const form = document.getElementById('subscribeForm') as HTMLFormElement | null;
  if (!form) return;
  const input = form.querySelector<HTMLInputElement>('input[type="email"]');
  const submit = form.querySelector<HTMLButtonElement>('button[type="submit"]');
  const status = form.querySelector<HTMLElement>('.subscribe-status');
  if (!input || !submit || !status) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = input.value.trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      status.textContent = 'Please enter a valid email.';
      status.dataset.kind = 'error';
      return;
    }
    submit.disabled = true;
    status.textContent = 'Sending…';
    status.dataset.kind = 'pending';
    try {
      const res = await fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, source: 'field-notes' }),
      });
      if (!res.ok) throw new Error(String(res.status));
      status.textContent = "You're in. NEUMA's first chapter lands in your inbox when it's ready.";
      status.dataset.kind = 'ok';
      input.value = '';
    } catch (_err) {
      status.innerHTML = `Endpoint not ready yet. Email <a href="mailto:${FALLBACK_EMAIL}?subject=NEUMA%20waitlist" class="fallback-link">${FALLBACK_EMAIL}</a> to be added by hand.`;
      status.dataset.kind = 'fallback';
    } finally {
      submit.disabled = false;
    }
  });
}
